import PropTypes from 'prop-types'
import clsx from 'clsx'

import styles from './style.module.scss'

/**
 * Kleines Info-Icon mit reinem CSS-Tooltip (Hover/Fokus). Kein JS, keine
 * externe Abhaengigkeit - funktioniert auch in Formularen ausserhalb des
 * App-Layouts und in Tests.
 */
export default function InfoTip({ text, className }) {
	return (
		<span className={clsx(styles.info, className)} tabIndex={0} aria-label={text}>
			i<span className={styles.tooltip}>{text}</span>
		</span>
	)
}

InfoTip.propTypes = {
	text: PropTypes.string.isRequired,
	className: PropTypes.string
}
